import { RightOutlined } from "@ant-design/icons";
import {

    Row,
    Col,

    Button,

    Form,
    Input,
    
    Select,
   
    Radio,
    
    Space,
   

} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import accountService from "../../../api/account.service";
import { addGst } from "../../../store/gstSlice";


import {  EDIT_MODE, SUCCESS_STATUS } from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";
import CustomMessage from "../../common/CustomMessage";
const { Option } = Select;



const GstEntry = ({ data , onDrawerClose }) => {
    const dispatch = useDispatch();

    // console.log(data)
    const [isFormResponse, setIsFormResponse] = useState(false);
    const [formResponseMessage, setFormResponseMessage] = useState("");
    const [formResponseStatus, setFormResponseStatus] = useState("");

    const [accountList, setAccountList] = useState([]);
    
    const [formDefaultValues, setFormDefaultValues] = useState({
        id: data.id,
        gstDescription: data.gstDescription,
        gstType: data.gstType,
        rate: data.rate,
        accountId: data.accountId,
        usedfor: data.usedfor,
        mode: data.mode,
    });

    const [mode, setMode] = useState(data.mode);


    const [form] = Form.useForm();

    const onGstSave = async (values) => {
     //   console.log(values);
        const data = { formdata: values };

          const response = accountService.gstSave(data).then((resdata) => {
            setIsFormResponse(true);
            setFormResponseStatus(resdata.response_status);
            setFormResponseMessage(resdata.response_msg);

            const x = {
                id:commonUtility.randomID(),
                gstDescription:values.gstDescription
            }
            dispatch(addGst(x))

        });

          
    };

    const onChange = (date, dateString) => {
      //  console.log(date, dateString);
    };

    const onGenderChange = (e) => {
      //  console.log(`radio checked:${e.target.value}`);
    };

    const onIsBeginerChange = (e) => {
        // console.log(`checked = ${e.target.checked}`);
    };


    const onChangeCollapse = (key) => {
     //   console.log(key);
    };

    const onGstApplicableChange = () => { };

    // useEffect(() => {
    //     form.setFieldsValue(formDefaultValues);
    // }, [form, formDefaultValues]);


    const hideResponseMessage = () => {
        setIsFormResponse(false);
        if(mode == "ADD") {
            form.resetFields();
            form.setFieldsValue({
                mode: formDefaultValues.mode,
                id:formDefaultValues.id
            })
        }
    }


    useEffect(() => {

       
        mode == EDIT_MODE ?

            form.setFieldsValue({
                id: formDefaultValues.id,
                gstDescription: formDefaultValues.gstDescription,
                gstType: formDefaultValues.gstType,
                rate: formDefaultValues.rate,
                accountId: formDefaultValues.accountId,
                usedfor: formDefaultValues.usedfor,
                mode: formDefaultValues.mode,

            })
            :
            form.setFieldsValue({
                id: 0,
                gstDescription: '',
                gstType: '',
                rate: '',
                accountId: '',
                usedfor: '',
                mode: data.mode
            });


        form.setFieldsValue(formDefaultValues)

    }, [form]);



    useEffect(() => {
        accountService.accountList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setAccountList(res.data.response_data);
            }

        });
    }, []);




    return (
        <div>
            <div className="form-input-style">

                <Row className="" style={{ background: "transparent" }}>
                    <Col className="" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onGstSave}
                            autoComplete="off"
                        // initialValues={formDefaultValues}
                        >

                            {/* <Row gutter={20}>
                            <Col className="gutter-row" xs={24} xl={24}>
                                <h5>Note: * fields are required</h5>
                            </Col>
                        </Row> */}
                            <Row gutter={20}>
                                <Col className="gutter-row" xs={24} xl={24}>

                                    <Form.Item name="gstDescription" label="Description" rules={[
                                        {
                                            required: true,
                                            message: 'Description is required',
                                        },
                                    ]}>
                                        <Input placeholder="" size="large" />
                                    </Form.Item>
                                    <Form.Item name="id" label="id" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                    <Form.Item name="mode" label="mode" hidden={true}>
                                        <Input type="text" />
                                    </Form.Item>
                                </Col>
                                
                                <Col xs={24} xl={24}>
                                    <Form.Item name="accountId" label="Account" rules={[
                                        {
                                            required: true,
                                            message: 'Account is required',
                                        },
                                    ]}>
                                    <Select className="text-left" showSearch
                                       placeholder="Search to Select"
                                       optionFilterProp="children"
                                       filterOption={(input, option) =>
                                        //    option.children.includes(input)
                                        option.children.toLowerCase().includes(input.toLowerCase())
                                       }
                                       filterSort={(optionA, optionB) =>
                                           optionA.children
                                               .toLowerCase()
                                               .localeCompare(optionB.children.toLowerCase())
                                       }
                                       placement="bottomLeft"
                                       allowClear={true}
                                       >
                                            
                                            {
                                                accountList.length > 0 ?
                                                    accountList.map(account_data => (
                                                        <Option key={account_data.id} value={account_data.id}>{account_data.account_name}</Option>

                                                    ))
                                                    : ''
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="gstType" label="Type" rules={[
                                        {
                                            required: true,
                                            message: 'Type is required',
                                        },
                                    ]}>
                                        <Select className="text-left" defaultValue="Select">
                                            <Option value="">Select</Option>
                                            <Option value="CGST">CGST</Option>
                                            <Option value="SGST">SGST</Option>
                                            <Option value="IGST">IGST</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="rate" label="Rate" rules={[
                                        {
                                            required: true,
                                            message: 'Rate is required',
                                        },
                                    ]}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="usedfor" label="Used For" rules={[
                                        {
                                            required: true,
                                            message: 'Used for is required',
                                        },
                                    ]}>
                                        <Radio.Group
                                            onChange={onGstApplicableChange}
                                            style={{ width: "100%" }}
                                            optionType="button"
                                            buttonStyle="solid"
                                        >
                                            <Radio.Button value="I">Input</Radio.Button>
                                            <Radio.Button value="O">Output</Radio.Button>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>
                              

                                <Col xs={24} xl={12}>
                                    <Form.Item name="" label=" ">
                                        <Space>

                                            <Button className="custom-button-green" htmlType="submit">
                                                Save <RightOutlined />
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col>


                            </Row>
                        </Form>



                    </Col>
                </Row>
                 {
                    // isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} /> : ''
                    isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
                 }                       
                



            </div>
        </div>
    );
};

export default GstEntry;
